exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.textfield[data-v-0f08dac6]{\n    width:90%;\n\tmargin-left:5%;\n\tmargin-right:5%;\n\tmargin-top:0px;\n\tfont-size:0px;\n\theight:0px;\n\topacity: 0;\n}\n.textfield[data-v-0f08dac6]:focus{\n\tmargin-top:16px;\n\theight:auto;\n\tfont-size:24px;\n\topacity: 100;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f08dac6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/edit/Edit_Inventory_Boxes.vue
// module id = 697
// module chunks = 0